import React, { useState } from 'react';
import { Dialog } from '../common/Dialog';
import { Button } from '../common/Button';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import * as styles from './LegalDialog.css.ts';
import privacyContentEn from '../../../../PRIVACY_POLICY.md?raw';
import privacyContentJa from '../../../../PRIVACY_POLICY_JA.md?raw';

interface PrivacyDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PrivacyDialog: React.FC<PrivacyDialogProps> = ({ isOpen, onClose }) => {
  const [language, setLanguage] = useState<'en' | 'ja'>('en');

  const content = language === 'en' ? privacyContentEn : privacyContentJa;
  const title = language === 'en' ? 'Privacy Policy' : 'プライバシーポリシー';

  const footer = (
    <Button variant="primary" onClick={onClose}>
      Close
    </Button>
  );

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      width="lg"
      footer={footer}
    >
      <div className={styles.languageToggle}>
        <button
          className={language === 'en' ? styles.languageButtonActive : styles.languageButton}
          onClick={() => setLanguage('en')}
        >
          English
        </button>
        <button
          className={language === 'ja' ? styles.languageButtonActive : styles.languageButton}
          onClick={() => setLanguage('ja')}
        >
          日本語
        </button>
      </div>
      <div className={styles.legalContent}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {content}
        </ReactMarkdown>
      </div>
    </Dialog>
  );
};
